import React, { useEffect, useState } from 'react';
import Routes from '../../Utils/routes.json';
import Home from '@material-ui/icons/Home';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import MailIcon from '@material-ui/icons/Mail';
import SmsIcon from '@material-ui/icons/Sms';
import EventAvailableOutlinedIcon from '@material-ui/icons/EventAvailableOutlined'; // event
import TableChartOutlinedIcon from '@material-ui/icons/TableChartOutlined'; //time table
import {
  Grid,
  IconButton,
  makeStyles,
  Menu,
  ListItem,
  Typography,
  Box,
  withStyles,
  List,
  Tooltip,
} from '@material-ui/core';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import Logo from '../../Assets/ken42-logo.jpg';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DashboardIcon from '@material-ui/icons/Dashboard';
import FlipCameraAndroidIcon from '@material-ui/icons/FlipCameraAndroid';
import StarBorder from '@material-ui/icons/StarBorder';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import {
  FaClipboardCheck,
  FaMoneyBill,
  FaSearchDollar,
  FaMoneyCheck,
  FaPercentage,
  FaRupeeSign,
  FaChessQueen,
  FaUserFriends,
  FaUserEdit,
  FaRegUserCircle,
  FaSatelliteDish,
  FaUserGraduate,
  FaUserTie,
  FaUsers,
} from 'react-icons/fa';
import AssessmentIcon from '@material-ui/icons/Assessment';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import PeopleIcon from '@material-ui/icons/People';
import CastIcon from '@material-ui/icons/Cast';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import PaymentIcon from '@material-ui/icons/Payment';
import AllOutIcon from '@material-ui/icons/AllOut';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import ReceiptIcon from '@material-ui/icons/Receipt';
import SchoolIcon from '@material-ui/icons/School';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import CancelIcon from '@material-ui/icons/Cancel';
import SwapHorizontalCircleIcon from '@material-ui/icons/SwapHorizontalCircle';
import RestoreIcon from '@material-ui/icons/Restore';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import CategoryIcon from '@material-ui/icons/Category';
import ViewQuiltSharpIcon from '@material-ui/icons/ViewQuiltSharp';
import ListAltSharpIcon from '@material-ui/icons/ListAltSharp';
import SupervisedUserCircleSharpIcon from '@material-ui/icons/SupervisedUserCircleSharp';
import AlarmOffSharpIcon from '@material-ui/icons/AlarmOffSharp';
import InsertInvitationSharpIcon from '@material-ui/icons/InsertInvitationSharp';
import LocationCitySharpIcon from '@material-ui/icons/LocationCitySharp';
import GroupWorkSharpIcon from '@material-ui/icons/GroupWorkSharp';
import AccountBalanceWalletSharpIcon from '@material-ui/icons/AccountBalanceWalletSharp';
import EventNoteIcon from '@material-ui/icons/EventNote';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AssignmentIcon from '@material-ui/icons/Assignment';
import InfoIcon from '@material-ui/icons/Info';
import DescriptionIcon from '@material-ui/icons/Description';
import SubjectIcon from '@material-ui/icons/Subject';
import MoneyIcon from '@material-ui/icons/Money';
import FormatAlignJustifyIcon from '@material-ui/icons/FormatAlignJustify';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import EventBusyIcon from '@material-ui/icons/EventBusy';
import NestedMenuItem from './NestedMenuItem';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import PieChartRoundedIcon from '@material-ui/icons/PieChartRounded';
import ViewListRoundedIcon from '@material-ui/icons/ViewListRounded';
import PostAddRoundedIcon from '@material-ui/icons/PostAddRounded';
import LibraryAddRoundedIcon from '@material-ui/icons/LibraryAddRounded';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import CustomMenuItem from './CustomMenuItem';
import { useTranslation } from 'react-i18next';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import ArrowDropDownCircleRounded from '@material-ui/icons/ArrowDropDownCircleRounded';
import { HiAcademicCap } from 'react-icons/hi';
import { RiUserSettingsLine } from 'react-icons/ri';
import { hasChildren } from './hasChilder';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import '../../style/index.css';
// const useStyles = makeStyles((theme) => ({
//   link: {
//     textDecoration: 'none',
//     color: '#fff',
//     '&:hover': {
//       textDecoration: 'none',
//       color: '#fff',
//     },
//     '&:focus': {
//       textDecoration: 'none',
//       color: '#fff',
//     },
//   },
//   listItem: {
//     padding: '12px 20px',
//     backgroundColor: 'inherit',
//   },
//   heading: {
//     fontSize: 14,
//     // fontWeight: 600,
//     color: theme.palette.KenColors.sideNavColor,
//     // marginLeft: !dataOpenDraver ? 28 : 10,
//     marginTop: '-8px',
//   },
//   menuIcon: {
//     color: theme.palette.KenColors.kenWhite,
//   },
//   logo: {
//     height: '48px',
//     background: theme.palette.KenColors.kenWhite,
//     marginLeft: 12,
//   },
//   closeIcon: {
//     marginRight: 8,
//     color: theme.palette.KenColors.kenWhite,
//     cursor: 'pointer',
//   },
//   closeLeftIcon: {
//     color: theme.palette.KenColors.kenWhite,
//     cursor: 'pointer',
//   },
//   menuButton: {
//     marginLeft: 8,
//   },
//   hide: {
//     display: 'none',
//   },
//   activeLinkInner: {
//     backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
//   },
//   activeLinkOuter: {
//     backgroundColor: theme.palette.KenColors.sideNavBackground,
//   },
//   menuTitle: {
//     color: theme.palette.KenColors.kenWhite,
//     padding: '16px',
//   },
//   popover: {
//     // marginTop: '-25px',
//     backgroundColor: theme.palette.KenColors.sideNavBackground,
//   },
//   listRoot: {
//     // backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
//     backgroundColor: 'inherit',
//     color: 'inherit',
//     opacity: 'inherit',
//     '&:hover': {
//       backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
//     },
//   },
//   list: {
//     padding: 0,
//     margin: 0,
//     '&:hover': {
//       backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
//     },
//   },
//   icon: {
//     color: theme.palette.KenColors.kenWhite,
//     fontSize: 10,
//     width: 10,
//   },
//   item: {
//     '&:hover': {
//       backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
//     },
//   },
//   fa: {
//     fontSize: '22px',
//     marginRight: '0.5rem',
//   },
//   header: {
//     padding: '8px 16px',
//     color: theme.palette.KenColors.kenWhite,
//     fontSize: '14px',
//     fontWeight: 600,
//   },
//   headerClass: {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     paddingTop: 8,
//   },
//   subMenuList: {
//     fontSize: '10px',
//   },
//   '& .makeStyles-label': {
//     fontSize: 10,
//   },
//   subMenuIcon: {
//     width: '18px',
//     height: '18px',
//   },
//   CollapseMenu: {
//     marginTop: '-20px',
//   },

//   expandIcon: {
//     paddingBottom: '4px',
//     width: 25,
//     height: 25,
//   },
// }));

// const LightTooltip = withStyles((theme) => ({
//   tooltip: {
//     backgroundColor: theme.palette.common.white,
//     color: 'rgba(0, 0, 0, 0.87)',
//     boxShadow: theme.shadows[1],
//     fontSize: 14,
//   },
// }))(Tooltip);

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: 'none',
    color: '#fff',
    fontSize: '12px',
    '&:hover': {
      textDecoration: 'none',
    },
    // '&:focus': {
    //   textDecoration: 'none',
    //   color: '#fff',
    //   backgroundColor: '#fff',
    // },
  },
  listItem: {
    padding: '12px 20px',
    backgroundColor: 'inherit',
    '&:hover': {
      backgroundColor: '#2e49a1',
    },
    '&:focus': {
      backgroundColor: '#2e49a1',
    },
  },
  heading: {
    fontSize: 14,
    // fontWeight: 600,
    color: theme.palette.KenColors.sideNavColor,
    marginLeft: 28,
    marginTop: '-8px',
  },
  menuIcon: {
    color: theme.palette.KenColors.kenWhite,
  },
  logo: {
    height: '48px',
    background: theme.palette.KenColors.kenWhite,
    marginLeft: 12,
  },
  closeIcon: {
    marginRight: 8,
    color: theme.palette.KenColors.kenWhite,
    cursor: 'pointer',
  },
  closeLeftIcon: {
    color: theme.palette.KenColors.kenWhite,
    cursor: 'pointer',
  },
  menuButton: {
    marginLeft: 8,
  },
  hide: {
    display: 'none',
  },
  activeLinkInner: {
    // backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
  },
  activeLinkOuter: {
    // backgroundColor: theme.palette.KenColors.sideNavBackground,
  },
  menuTitle: {
    // color: theme.palette.KenColors.kenWhite,
    padding: '16px',
  },
  popover: {
    // marginTop: '-25px',
    backgroundColor: theme.palette.KenColors.sideNavBackground,
  },
  listRoot: {
    // backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    backgroundColor: 'inherit',
    color: 'inherit',
    opacity: 'inherit',
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  list: {
    padding: 0,
    margin: 0,
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  icon: {
    color: theme.palette.KenColors.kenWhite,
    fontSize: 14,
  },
  item: {
    '&:hover': {
      backgroundColor: theme.palette.KenColors.sideNavBackgroundSecondary,
    },
  },
  fa: {
    fontSize: '22px',
    marginRight: '0.5rem',
  },
  header: {
    padding: '8px 16px',
    color: theme.palette.KenColors.kenWhite,
    fontSize: '14px',
    fontWeight: 600,
  },
  headerClass: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 8,
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}))(Tooltip);
// const classes = useStyles();

const menus = [
  {
    id: 1,
    icon: <HiAcademicCap />,
    label: 'Academic Planning',
    isParent: true,
    items: [
      // {
      //   icon: <ArrowDropDownCircleRounded />,
      //   label: 'Home',
      //   path: Routes.academicsPlanner,
      // },

      {
        icon: <PostAddRoundedIcon />,
        label: 'Add Program/Intake/Specialization',
        path: Routes.addProgram,
        isParent: false,
      },
      {
        icon: <ViewListRoundedIcon />,
        label: 'Current Batches',
        path: Routes.currentProgrammes,
        isParent: false,
      },
      {
        icon: <LibraryAddRoundedIcon />,
        label: 'Add Subject',
        path: Routes.facultyDetails,
        isParent: false,
      },
      {
        icon: <ArrowDropDownCircleRounded />,
        label: 'Faculty Onboarding',
        isParent: false,
        // path: Routes.facultySection,
        items: [
          {
            icon: <ArrowDropDownCircleRounded />,
            label: 'Faculty Invitation',
            path: Routes.facultySection,
            isParent: false,
            isSubSubMenu: true,
          },
          {
            icon: <ArrowDropDownCircleRounded />,
            label: 'Contract Management',
            path: Routes.contractManagement,
            isParent: false,
            isSubSubMenu: true,
          },
          {
            icon: <ArrowDropDownCircleRounded />,
            label: 'Subject Documents',
            path: Routes.subjectDocuments,
            isParent: false,
            isSubSubMenu: true,
          },
        ],
      },
      {
        icon: <LibraryAddRoundedIcon />,
        label: 'Add Activity',
        path: Routes.addActivity,
        isParent: false,
      },
      {
        icon: <SupervisedUserCircleSharpIcon />,
        label: 'Faculty Management',
        path: Routes.facultySection,
        icon: <ArrowDropDownCircleRounded />,
        label: 'Full Calendar',
        path: Routes.fullCalendar,
        isParent: false,
      },
      //  {
      //   icon: <SupervisedUserCircleSharpIcon />,
      //   label: 'New TimeTable',
      //   path: Routes.sessiontimeTableNew,
      //   label: 'New Time Table',
      //   isParent: false,
      // },
      {
        icon: <EventNoteIcon />,
        label: 'Time Table',
        path: Routes.sessiontimeTable,
        isParent: false,
      },
      {
        icon: <CalendarTodayIcon />,
        label: 'Planner',
        path: Routes.sessionScheduler,
      },
      {
        icon: <CalendarTodayIcon />,
        label: 'Session Planner',
        path: Routes.sessionPlanner,
      },
      {
          icon: <CalendarTodayIcon />,
          label: 'Academic Calendar',
          path: Routes.academicCalendar,
      }
    ],
  },
  {
    id: 2,
    icon: <RiUserSettingsLine />,
    label: 'Exam Management',
    callback: '',
    isParent: true,
    items: [
      {
        icon: <DashboardIcon />,
        label: 'Dashboard',
        path: Routes.exam,
        isParent: false,
      },
      {
        icon: <PeopleIcon />,
        label: 'Student Status',
        path: Routes.studentStatus,
        isParent: false,
      },
      {
        icon: <QuestionAnswerIcon />,
        label: 'Question Paper',
        path: Routes.questionPaper,
        isParent: false,
      },
      {
        icon: <EventNoteIcon />,
        label: 'Timetable & Seating plan',
        path: Routes.seatingPlan,
        isParent: false,
      },
      {
        icon: <SubjectIcon />,
        label: 'Invigilation & Proctoring',
        path: Routes.invigilationProctoring,
        isParent: false,
      },
      {
        icon: <AssignmentIcon />,
        label: 'Evaluation',
        path: Routes.evaluation,
        isParent: false,
      },
      {
        icon: <PieChartRoundedIcon />,
        label: 'Grading',
        path: Routes.grading,
        isParent: false,
      },
      {
        icon: <FlipCameraAndroidIcon />,
        label: 'Revaluation & Retest',
        path: Routes.revaluationRetest,
        isParent: false,
      },
    ],
  },
  {
    id: 3,
    icon: <FaUserGraduate />,
    label: 'Enrollment',
    callback: '',
    isParent: true,
    items: [
      {
        icon: <FaUsers />,
        label: 'Student',
        path: Routes.enrollStudent,
        isParent: false,
      },
      {
        icon: <FaUserTie />,
        label: 'Faculty',
        path: Routes.enrollFaculty,
        isParent: false,
      },
    ],
  },
];

const MenuItem = ({ item, openDrawer, setOpen }) => {
  console.log('openDrawer,openDrawer', openDrawer);
  const Component = hasChildren(item) ? MultiLevel : SingleLevel;
  return <Component openDrawer={openDrawer} setOpen={setOpen} item={item} />;
};

const SingleLevel = ({ item, openDrawer }) => {
  const classes = useStyles();
  return (
    <>
      <ListItem
        className={!item.isSubSubMenu ? 'sub-menu' : 'sub-menu-not'}
        button
      >
        <ListItemIcon style={{ color: '#fff', fontSize: '12px' }}>
          {item.icon}
        </ListItemIcon>
        <NavLink
          // key={key}
          className={classes.link}
          to={item?.path || ''}
          activeClassName={classes.activeLinkInner}
          exact
        >
          <ListItemText className="sub-menu-text" primary={item.label} />
        </NavLink>
      </ListItem>
    </>
  );
};

const MultiLevel = ({ item, key, openDrawer }) => {
  const classes = useStyles();
  const { items: children } = item;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (openDrawer === false) {
      return;
    }
    setOpen((prev) => !prev);
  };
  useEffect(() => {
    if (openDrawer === false) {
      setOpen(false);
    }
  }, [openDrawer]);

  return (
    <React.Fragment>
      <ListItem
        button
        className={item.isParent ? '' : 'submenu-not-parent'}
        onClick={(e) => handleClick(openDrawer)}
      >
        {console.log('openopenopenopenopenopen', openDrawer)}
        <ListItemIcon
          className={
            !openDrawer && item.isParent
              ? 'side-nav-main-icon-drawerClose'
              : 'side-nav-main-icon'
          }
          style={{ color: '#fff' }}
        >
          {item.icon}
        </ListItemIcon>
        <NavLink
          key={key}
          className={classes.link}
          to="#"
          activeClassName={classes.activeLinkInner}
          exact
        >
          {item.isParent ? (
            <ListItemText
              className="side-nav-main-text"
              style={{ color: '#fff' }}
              primary={item.label}
            />
          ) : (
            <ListItemText
              className="sub-menu-text"
              style={{ color: '#fff' }}
              primary={item.label}
            />
          )}
        </NavLink>

        {open ? (
          <ExpandLessIcon style={{ color: '#fff' }} />
        ) : (
          <ExpandMoreIcon style={{ color: '#fff' }} />
        )}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List style={{ color: '#fff' }} disablePadding>
          {children.map((child, key) => (
            <MenuItem key={key} item={child} />
          ))}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export const SideNavigation = (props) => {
  const { openDrawer, setOpenDrawer } = props;

  // Tetsdata
  const classes = useStyles();
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedSubItems, setSelectedSubItems] = useState([]);
  const { t } = useTranslation();

  // const handleClick = () => {
  //   setOpen(!open);
  // };

  const menuListData = menus.map((single) => {
    return { id: single.id, val: false };
  });

  const [open, setOpen] = useState(menuListData);
  const handleMenuClick = (event, item) => {
    if (Array.isArray(item.subItems) && item?.subItems?.length > 0) {
      setSelectedSubItems(item);
      if (menuPosition) {
        return;
      }
      event.preventDefault();
      let currentTargetRect = event.currentTarget.getBoundingClientRect();
      const event_offsetX = currentTargetRect.top - 25;
      const event_offsetY = currentTargetRect.right;

      setMenuPosition({
        top: event_offsetX,
        left: event_offsetY,
      });
    } else {
      setSelectedSubItems([]);
      return;
    }
  };

  const handleItemClick = (event) => {
    setMenuPosition(null);
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setOpen(false);
  };

  const customRender = (items) => {
    if (!Array.isArray(items)) return <></>;
    return items?.map((item, index) => {
      if (item.subItems) {
        return (
          <NestedMenuItem
            label={item.label}
            parentMenuOpen={!!menuPosition}
            PaperProps={{ className: classes.popover }}
            icon={item.icon}
            index={index}
            header={item.label}
          >
            {customRender(item.subItems)}
          </NestedMenuItem>
        );
      }
      return item?.path ? (
        <NavLink
          key={index}
          className={classes.link}
          to={item?.path}
          activeClassName={classes.activeLinkInner}
          exact
        >
          <CustomMenuItem
            key={index}
            onClick={handleItemClick}
            icon={item.icon}
            label={item.label}
            openDrawer={openDrawer}
          ></CustomMenuItem>
        </NavLink>
      ) : (
        <CustomMenuItem
          key={index}
          onClick={handleItemClick}
          icon={item.icon}
          label={item.label}
          openDrawer={openDrawer}
          className={classes.icon}
        ></CustomMenuItem>
      );
    });
  };
  // const handleMenuClick = (event, item, id) => {
  //   if (Array.isArray(item.subItems) && item?.subItems?.length > 0) {
  //     setOpenDrawer(true);

  //     setOpen((prev) => {
  //       return prev.map((submenu) => {
  //         if (submenu.id === id) {
  //           return { ...submenu, val: !submenu.val };
  //         } else {
  //           return { ...submenu, val: false };
  //         }
  //       });
  //     });

  //     setSelectedSubItems(item);
  //     if (menuPosition) {
  //       return;
  //     }
  //   } else {
  //     setSelectedSubItems([]);
  //     setOpen((prev) => {
  //       return prev.map((submenu) => {
  //         if (submenu.id === id) {
  //           return { ...submenu, val: submenu.val };
  //         } else {
  //           return submenu;
  //         }
  //       });
  //     });
  //     return;
  //   }
  // };

  // const handleItemClick = (event) => {
  //   setMenuPosition(null);
  // };

  // const handleDrawerOpen = () => {
  //   setOpenDrawer(true);
  // };

  // const handleDrawerClose = (id) => {
  //   setOpenDrawer(false);
  //   setOpen((prev) => {
  //     return prev.map((submenu) => {
  //       return { ...submenu, val: false };
  //     });
  //   });
  // };

  // const customRender = (items) => {
  //   if (!Array.isArray(items)) return <></>;
  //   return items?.map((item, index) => {
  //     if (item.subItems) {
  //       return (
  //         <NestedMenuItem
  //           label={item.label}
  //           parentMenuOpen={!!menuPosition}
  //           PaperProps={{ className: classes.popover }}
  //           icon={item.icon}
  //           index={index}
  //           header={item.label}
  //           className={classes.subMenuList}
  //         >
  //           {customRender(item.subItems)}
  //         </NestedMenuItem>
  //       );
  //     }
  //     return item?.path ? (
  // <NavLink
  //   key={index}
  //   className={classes.link}
  //   to={item?.path}
  //   activeClassName={classes.activeLinkInner}
  //   exact
  // >
  //         <CustomMenuItem
  //           key={index}
  //           onClick={handleItemClick}
  //           icon={item.icon}
  //           label={item.label}
  //           openDrawer={openDrawer}
  //         ></CustomMenuItem>
  //       </NavLink>
  //     ) : (
  //       <CustomMenuItem
  //         key={index}
  //         onClick={handleItemClick}
  //         icon={item.icon}
  //         label={item.label}
  //         openDrawer={openDrawer}
  //         className={classes.icon}
  //       ></CustomMenuItem>
  //     );
  //   });
  // };

  return (
    <div className="testforscrollbar">
      <Box className={classes.root}>
        {console.log('openDrawer', openDrawer)}
        <Grid className={classes.headerClass}>
          {openDrawer === true ? (
            <>
              <img src={Logo} className={classes.logo} />
              <div className={classes.toolbar}>
                <FormatAlignRightIcon
                  onClick={handleDrawerClose}
                  className={classes.closeIcon}
                />
              </div>
            </>
          ) : (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={classes.menuButton}
            >
              <FormatAlignLeftIcon className={classes.closeLeftIcon} />
            </IconButton>
          )}
        </Grid>
      </Box>

      {menus?.map((item, key) => (
        <List
          className={!item.isParent ? 'submenu-submenu-padding' : ''}
          component="div"
          disablePadding
        >
          <MenuItem key={key} openDrawer={openDrawer} item={item} />
        </List>
        // <>
        //   <NavLink
        //     key={key}
        //     className={classes.link}
        //     onClick={(e) => handleMenuClick(e, item)}
        //     to={
        //       item?.path === null || item?.path === undefined ? (
        //         <Typography>{item?.path}</Typography>
        //       ) : (
        //         item?.path
        //       )
        //     }
        //     activeClassName={classes.activeLinkOuter}
        //     exact
        //   >

        //   </NavLink>
        // </>
      ))}
      {/* {menus?.map((item, index) => (
        <>
          {console.log('item---------------', item)}
          <NavLink
            key={index}
            className={classes.link}
            onClick={(e) => handleMenuClick(e, item, item.id)}
            to={
              item?.path === null || item?.path === undefined ? (
                <Typography>{item?.path}</Typography>
              ) : (
                item?.path
              )
            }
            activeClassName={classes.activeLinkOuter}
            exact
          >
            <ListItem
              classes={{
                root: classes.listItem,
                //   selected: classes.active,
              }}
              button
            >
              {openDrawer === false ? (
                <LightTooltip title={item.label} placement="right-end">
                  <span className={classes.menuIcon}>
                    <Typography>{item.icon}</Typography>
                  </span>
                </LightTooltip>
              ) : (
                <span className={classes.menuIcon}>
                  <Typography>{item.icon}</Typography>
                </span>
              )}
              <span
                className={classes.heading}
                style={
                  openDrawer === true ? { marginLeft: 10 } : { marginLeft: 28 }
                }
              >
                {item?.label}
              </span>
              {open[index].val ? (
                <ExpandLess className={classes.expandIcon} />
              ) : (
                <ExpandMore className={classes.expandIcon} />
              )}
            </ListItem>
          </NavLink>
          {item.subItems && (
            <Collapse
              in={open[index].val}
              timeout="auto"
              style={{
                paddingLeft: 34,
              }}
              unmountOnExit
            >
              <div style={{ marginTop: '-15px' }}>
                {selectedSubItems && (
                  <List>
                    <div className="abababab">
                      {customRender(item.subItems)}
                    </div>
                  </List>
                )}
              </div>
            </Collapse>
          )}
        </>
      ))} */}
      {/* </List> */}
    </div>

    // <div>
    //   <Box className={classes.root}>
    //     <Grid className={classes.headerClass}>
    //       {openDrawer === true ? (
    //         <>
    //           <img src={Logo} className={classes.logo} />
    //           <div className={classes.toolbar}>
    //             <FormatAlignRightIcon
    //               onClick={handleDrawerClose}
    //               className={classes.closeIcon}
    //             />
    //           </div>
    //         </>
    //       ) : (
    //         <IconButton
    //           color="inherit"
    //           aria-label="open drawer"
    //           onClick={handleDrawerOpen}
    //           edge="start"
    //           className={classes.menuButton}
    //         >
    //           <FormatAlignLeftIcon className={classes.closeLeftIcon} />
    //         </IconButton>
    //       )}
    //     </Grid>
    //   </Box>

    //   <List>
    //     {menus?.map((item, key) => (
    //       <>
    //         <NavLink
    //           key={key}
    //           className={classes.link}
    //           onClick={(e) => handleMenuClick(e, item)}
    //           to={
    //             item?.path === null || item?.path === undefined ? (
    //               <Typography>{item?.path}</Typography>
    //             ) : (
    //               item?.path
    //             )
    //           }
    //           activeClassName={classes.activeLinkOuter}
    //           exact
    //         >
    //           <ListItem
    //             classes={{
    //               root: classes.listItem,
    //               //   selected: classes.active,
    //             }}
    //             button
    //           >
    //             {openDrawer === false ? (
    //               <LightTooltip title={item.label} placement="right-end">
    //                 <span className={classes.menuIcon}>
    //                   <Typography>{item.icon}</Typography>
    //                 </span>
    //               </LightTooltip>
    //             ) : (
    //               <span className={classes.menuIcon}>
    //                 <Typography>{item.icon}</Typography>
    //               </span>
    //             )}
    //             <span className={classes.heading}>{item?.label}</span>
    //           </ListItem>
    //         </NavLink>
    //         {selectedSubItems && (
    //           <Menu
    //             open={!!menuPosition}
    //             onClose={() => setMenuPosition(null)}
    //             anchorReference="anchorPosition"
    //             anchorPosition={menuPosition}
    //             PaperProps={{
    //               className: classes.popover,
    //               elevation: 1,
    //             }}
    //             header={item?.label}
    //           >
    //             <Typography variant="body1" className={classes.header}>
    //               {selectedSubItems?.label}
    //             </Typography>
    //             {customRender(selectedSubItems?.subItems)}
    //           </Menu>
    //         )}
    //       </>
    //     ))}
    //   </List>
    // </div>
  );
};

export default SideNavigation;
